<template>
  <div class="personnel">
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <h2>Personnel Detail</h2>
        </div>
      </div>
    </div>

    <div class="col-12" v-if="personnel">
      <div class="row">
        <div class="col-2">
          <label for="name">Name:</label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="name"
            ref="personnel_name"
            name="name"
            placeholder="name"
            :value="getName()"
          />
        </div>
        <div
          v-if="submitted && errors.has('name')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("name") }}
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="position">Position:</label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="position"
            ref="personnel_position"
            name="position"
            placeholder="position"
            :value="getPosition()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h3>Address</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="address1">Address 1:</label>
        </div>
        <div class="col-6">
          <input
            type="text"
            class="form-control"
            id="address1"
            name="address1"
            ref="personnel_address_line_1"
            placeholder=""
            :value="getAddressLine1()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="address2">Address 2:</label>
        </div>
        <div class="col-6">
          <input
            type="text"
            class="form-control"
            id="address2"
            name="address2"
            ref="personnel_address_line_2"
            placeholder=""
            :value="getAddressLine2()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="address3">Address 3:</label>
        </div>
        <div class="col-6">
          <input
            type="text"
            class="form-control"
            id="address3"
            name="address3"
            ref="personnel_address_line_3"
            placeholder=""
            :value="getAddressLine3()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="city">City:</label>
        </div>
        <div class="col-4">
          <input
            type="text"
            class="form-control"
            id="city"
            name="city"
            placeholder="city"
            ref="personnel_address_city"
            :value="getAddressCity()"
          />
        </div>
        <div class="col-1">
          <label for="state">State:</label>
        </div>
        <div class="col-1 no-padding">
          <input
            type="text"
            class="form-control"
            id="state"
            name="state"
            placeholder="state"
            ref="personnel_address_state"
            :value="getAddressState()"
          />
        </div>
        <div class="col-2">
          <label for="postcode">Postcode:</label>
        </div>
        <div class="col-1 no-padding">
          <input
            type="text"
            class="form-control"
            id="postcode"
            name="postcode"
            ref="personnel_address_postcode"
            placeholder="0000"
            :value="getAddressPostcode()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h3>Other Details</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="phone">Phone:</label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="phone"
            ref="personnel_phone"
            name="phone"
            placeholder="phone"
            :value="getPhone()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="mobile">Mobile:</label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="mobile"
            ref="personnel_mobile"
            name="mobile"
            placeholder="mobile"
            :value="getMobile()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="email">Email:</label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="email"
            ref="personnel_email"
            name="email"
            placeholder="email"
            :value="getEmail()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <label for="notes">Notes:</label>
        </div>
        <div class="col-9">
          <textarea
            rows="4"
            class="form-control"
            id="notes"
            ref="personnel_notes"
            name="notes"
            placeholder="notes"
            :value="getNotes()"
          />
        </div>
        <div
          v-if="submitted && errors.has('notes')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("notes") }}
        </div>
      </div>
    </div>

    <CreatePasswordModal
      ref="create_password_modal"
      :personnel="personnel"
      v-show="showPassword"
      @close="_closeCreatePasswordModal"
    />

    <div class="row">
      <div class="col-10">
        <button id="new" @click="$emit('new')" class="btn btn-plt">New</button>
        <button v-if="personnel" id="save" @click="save" class="btn btn-plt">
          Save
        </button>
        <button
          v-if="personnel"
          id="password"
          @click="password"
          class="btn btn-plt"
        >
          Create Password
        </button>
      </div>

      <div class="col-2" v-if="personnel">
        <button
          id="delete"
          v-if="personnel.active"
          @click="_delete"
          class="btn btn-danger"
        >
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CreatePasswordModal from "./CreatePasswordModal.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "PersonnelDetail",
  computed: {
    ...mapState("personnels", ["personnelsPasswordUpdated"]),
  },
  props: {
    personnel: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    submitted: false,
    showPassword: false,
  }),
  // WATCH
  watch: {
    personnelsPasswordUpdated() {
      this.$refs.create_password_modal.clear();
    },
  },
  methods: {
    ...mapActions("personnels", ["apiSavePersonnel", "apiCreatePersonnel"]),
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.save();
        }
      });
    },
    _delete() {
      if (this.personnel && this.personnel.id > 0) {
        this.personnel.active = !this.personnel.active;
        this.apiSavePersonnel(this.personnel);
      }
    },
    save() {
      if (this.personnel) {
        if (!this.$refs.personnel_name.value) {
          alert("please enter a name");
          return;
        }
        this.personnel.name = this.$refs.personnel_name.value;
        this.personnel.position = this.$refs.personnel_position.value;
        this.personnel.address.address1 =
          this.$refs.personnel_address_line_1.value;
        this.personnel.address.address2 =
          this.$refs.personnel_address_line_2.value;
        this.personnel.address.address3 =
          this.$refs.personnel_address_line_3.value;
        this.personnel.address.city = this.$refs.personnel_address_city.value;
        this.personnel.address.state = this.$refs.personnel_address_state.value;
        this.personnel.address.postcode =
          this.$refs.personnel_address_postcode.value;
        this.personnel.phone = this.$refs.personnel_phone.value;
        this.personnel.mobile = this.$refs.personnel_mobile.value;
        this.personnel.email = this.$refs.personnel_email.value;
        this.personnel.notes = this.$refs.personnel_notes.value;
        this.personnel.active = true;

        if (this.personnel.id > 0) {
          this.apiSavePersonnel(this.personnel);
        } else {
          this.apiCreatePersonnel(this.personnel);
        }
        this.$emit("saved");
      }
    },

    password() {
      this.showPassword = true;
    },

    _closeCreatePasswordModal() {
      this.showPassword = false;
    },

    getName() {
      if (this.personnel == null) {
        return "";
      } else {
        return this.personnel.name;
      }
    },
    getPosition() {
      if (this.personnel == null) {
        return "";
      } else {
        return this.personnel.position;
      }
    },
    getAddressLine1() {
      if (!this.personnel || !this.personnel.address) {
        return "";
      }
      return this.personnel.address.address1;
    },
    getAddressLine2() {
      if (!this.personnel || !this.personnel.address) {
        return "";
      }
      return this.personnel.address.address2;
    },
    getAddressLine3() {
      if (!this.personnel || !this.personnel.address) {
        return "";
      }
      return this.personnel.address.address3;
    },
    getAddressCity() {
      if (!this.personnel || !this.personnel.address) {
        return "";
      }
      return this.personnel.address.city;
    },
    getAddressState() {
      if (!this.personnel || !this.personnel.address) {
        return "";
      }
      return this.personnel.address.state;
    },
    getAddressPostcode() {
      if (!this.personnel || !this.personnel.address) {
        return "";
      }
      return this.personnel.address.postcode;
    },
    getPhone() {
      if (this.personnel == null) {
        return "";
      } else {
        return this.personnel.phone;
      }
    },
    getEmail() {
      if (this.personnel == null) {
        return "";
      } else {
        return this.personnel.email;
      }
    },
    getMobile() {
      if (this.personnel == null) {
        return "";
      } else {
        return this.personnel.mobile;
      }
    },
    getNotes() {
      if (this.personnel == null) {
        return "";
      } else {
        return this.personnel.notes;
      }
    },
  },
  components: {
    CreatePasswordModal,
  },
};
</script>
